module.exports = __webpack_public_path__ + "media/KikiV.cec26db0.mp3";